import { fetchCoursewareCommentLikeList } from '@/api/app/course';
export default {
  data() {
    return {
      postId: undefined, // post id
      coursewareCommentLikeLoaded: false,
      coursewareCommentLikeData: [],
      coursewareCommentLikePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
    }
  },
  mounted() {
    this.coursewareCommentLikeLoaded = false;
  },
  methods: {
    initCoursewareCommentLike() {
      if (this.coursewareCommentLikeLoaded) {
        return;
      }

      this.getCoursewareCommentLikeList();
    },
    getCoursewareCommentLikeList() {
      this.coursewareCommentLikeLoaded = true;
      let params = {
        current: this.coursewareCommentLikePage.currentPage,
        size: this.coursewareCommentLikePage.pageSize,
        postId: this.postId
      }
      fetchCoursewareCommentLikeList(params).then(response => {
        if (response.data.data != null) {
          this.coursewareCommentLikeData = response.data.data.records;
          this.coursewareCommentLikePage.total = response.data.data.total;
        } else  {
          this.coursewareCommentLikeData = []
          this.coursewareCommentLikePage.total = 0;
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取点赞列表失败',
          type: 'error'
        });
      });
      this.coursewareCommentLikeLoaded = false;
    },
    coursewareCommentLikeCurrentChange(val) {
      this.coursewareCommentLikePage.currentPage = val;
      this.getCoursewareCommentLikeList();
    },
    coursewareCommentLikeSizeChange(val) {
      this.coursewareCommentLikePage.pageSize = val;
      this.getCoursewareCommentLikeList();
    },
  }
}
